import React from "react";
import train from "../Images/Icons/train.png";



export const TrainsSectionTitle = props => {
  

  return (
    <div className="trainstop-header d-flex align-items-center">
              <img src={train} alt="train icon" />
              <span className="trainstop-header__title">Odjazdy | Kolej</span>
            </div>
  );
};
